import {Items} from './SimpleListView/Items'
import SimpleListViewContainer from './SimpleListView/SimpleListViewContainer'

export const SimpleListView = Object.assign(SimpleListViewContainer, {
  Items,
})
